// i18n
import './locales/i18n';

// scroll bar
import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------
import axios from 'axios';
import * as LocalStorage from 'local-storage';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { configureUnauthorizedHandler } from './utils/unauthorizedHandler';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import SnackbarProvider from './components/snackbar';
import { SettingsProvider } from './components/settings';
import { MotionLazyContainer } from './components/animate';
import ScrollToTop from './components/scroll-to-top';
import SessionExpiredPopupHost from './components/SessionExpiredPopupHost';

// Check our docs
// https://docs.minimals.cc/authentication/js-version

import { AuthProvider } from './auth/JwtContext';

// ----------------------------------------------------------------------
// axios.defaults.headers.common.Authorization = `Bearer ${LocalStorage.get("_UserToken")}`;
axios.defaults.headers.common.authheader = `${LocalStorage.get("_UserToken")}`;
axios.defaults.headers.common['Content-Type'] = 'application/json';
configureUnauthorizedHandler(axios);

// Global response interceptor to handle 409 Conflict (data import running)
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 409) {
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);


export default function App() {
    return (
        <AuthProvider>
            <HelmetProvider>
                <SettingsProvider>
                    <BrowserRouter>
                        <ScrollToTop />
                        <MotionLazyContainer>
                            <ThemeProvider>
                                {/* <ThemeSettings> */}
                                <ThemeLocalization>
                                    <SnackbarProvider>
                                        <Router />
                                    </SnackbarProvider>
                                </ThemeLocalization>
                                <SessionExpiredPopupHost />
                                {/*  </ThemeSettings> */}
                            </ThemeProvider>
                        </MotionLazyContainer>
                    </BrowserRouter>
                </SettingsProvider>
            </HelmetProvider>
        </AuthProvider>
    );
}
